import React, { Component } from 'react';
import {connect} from 'react-redux';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';

class OscillatorsContinuedComponent extends Component {
    render() {
        let oscillator = this.props.instrument.getOscillator(this.props.selectedOscillator);
        let instrument = this.props.instrument;
        return (
            <div className="oscillators-continued">
               <EffectParameterSlider
                  sequencerEngine={this.props.sequencerEngine}
                  automation={this.props.automation}
                  name={'Feedback'}
                  parameter={instrument.feedbackParameter}
                 root={2}
                  lfoEnabled={true}
                  onParameterChanged={() => []}
                  isParameter={true}
                  min={0}
                  max={6}
                  step={0.001}
                  />
             <EffectParameterSlider
                sequencerEngine={this.props.sequencerEngine}
                automation={this.props.automation}
                name={'Polyphony'}
                parameter={instrument.polyphonyParameter}
                onParameterChanged={() => []}
                isParameter={true}
                min={1}
                max={6}
                step={1}
              />
              <EffectParameterSlider
                sequencerEngine={this.props.sequencerEngine}
                automation={this.props.automation}
                name={'Glide'}
                parameter={oscillator.portamentoParameter}
                onParameterChanged={() => []}
                isParameter={true}
                min={0}
                        max={5}
                step={0.01}
              />
                <EffectParameterSlider
                  sequencerEngine={this.props.sequencerEngine}
                  automation={this.props.automation}
                  name={'X/Y Mix'}
                  parameter={instrument.mixParameter}
                  onParameterChanged={() => []}
                  isParameter={true}
                  lfoEnabled={true}
                  min={0}
                  max={1}
                  step={0.01}
                  />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
  return {
      algorithm: props.instrument.algorithmParameter.get(),
      adjacencyLists: props.instrument.adjacencyLists,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OscillatorsContinuedComponent);

